import { render, staticRenderFns } from "./vue-textarea.vue?vue&type=template&id=27a3a315&lang=html&"
import script from "./vue-textarea.vue?vue&type=script&lang=js&"
export * from "./vue-textarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports